import React from 'react';
import EventsContainer from './../../../Containers/AdminContainer/Events/index';
const EventsScreen = () => {
  return <EventsContainer />;
};

export default EventsScreen;
